/**
 * LogosOS UI System: ThinkingConfig Defaults v1.1
 *
 * Canonical default configurations by UI context.
 * Use these when no explicit config is provided.
 *
 * v1.1 DEFAULT MAPPINGS (PM spec):
 * - calm    → visualEmphasis: minimal,  motionComplexity: still
 * - standard→ visualEmphasis: normal,   motionComplexity: ambient
 * - focused → visualEmphasis: elevated, motionComplexity: ambient
 * - urgent  → visualEmphasis: elevated, motionComplexity: expressive
 */

import type { ThinkingConfig, ThinkingContext, ThinkingBreathMode } from "./types"

/**
 * Get default ThinkingConfig for a given UI context
 */
export function getDefaultThinkingConfig(context: ThinkingContext): ThinkingConfig {
  switch (context) {
    case "watermark":
      return {
        version: "1.1",
        active: false,
        breathMode: "calm",
        visualEmphasis: "minimal",
        motionComplexity: "still",
      }

    case "watermark-large":
      return {
        version: "1.1",
        active: false,
        breathMode: "calm",
        visualEmphasis: "minimal",
        motionComplexity: "still",
      }

    case "inline":
      return {
        version: "1.1",
        active: false,
        breathMode: "standard",
        visualEmphasis: "normal",
        motionComplexity: "ambient",
      }

    case "overlay":
      return {
        version: "1.1",
        active: false,
        breathMode: "focused",
        visualEmphasis: "elevated",
        motionComplexity: "ambient",
      }
  }
}

/**
 * Get recommended VisualEmphasis + MotionComplexity for a BreathMode
 */
export function getRecommendedSemantics(breathMode: ThinkingBreathMode): {
  visualEmphasis: "minimal" | "normal" | "elevated"
  motionComplexity: "still" | "ambient" | "expressive"
} {
  switch (breathMode) {
    case "calm":
      return { visualEmphasis: "minimal", motionComplexity: "still" }
    case "standard":
      return { visualEmphasis: "normal", motionComplexity: "ambient" }
    case "focused":
      return { visualEmphasis: "elevated", motionComplexity: "ambient" }
    case "urgent":
      return { visualEmphasis: "elevated", motionComplexity: "expressive" }
  }
}
